import React, { useCallback, useState } from "react";
import update from "immutability-helper";
import ReportFieldsConstructorItem from "./ReportFieldsConstructorItem.js";
import Scrollbars from "react-custom-scrollbars-2";
import styles from "./reportContructor.module.scss";
import { ReportFieldsDnDItem } from "./ReportFieldsDnDItem.js";

export const ReportFieldsDnDContainer = (props) => {
  {
    const { selectedField, countFixFields, onSelectHandle, onUpdateHandler, onShiftHandle } = props;
    const [fields, setFields] = useState(props.fields);

    const moveField = useCallback((dragIndex, hoverIndex, field) => {
      if (dragIndex === NaN || hoverIndex === NaN) return;

      setFields((prevFields) =>
        update(prevFields, {
          $splice: [
            [dragIndex + countFixFields, 1],
            [hoverIndex + countFixFields, 0, prevFields[dragIndex + countFixFields]],
          ],
        })
      );
    }, []);

    const onShift = useCallback((field, index) => {
      if (index + 1 !== field.number - countFixFields) {
        onShiftHandle(field, index + countFixFields + 1);
      }
    }, []);

    const onSelect = useCallback((field) => {
      onSelectHandle(field);
    }, []);

    const onUpdate = useCallback(() => {
      onUpdateHandler();
    }, []);

    const renderField = useCallback((field, index) => {
      const isSelect = selectedField !== null && selectedField.id === field.id;
      const currentField = isSelect ? selectedField : field;
      const selectFieldId = isSelect ? selectedField.id : null;

      if (currentField === undefined || currentField === null) return null;

      if (currentField.number <= countFixFields) {
        return (
          <ReportFieldsConstructorItem
            key={currentField.id}
            field={currentField}
            onSelectHandle={onSelectHandle}
            onUpdateHandler={onUpdateHandler}
            isSelect={isSelect}
            title={field.dashboard.title}
            cssColumnWidth={field.cssColumnWidth}
          />
        );
      }

      return (
        <ReportFieldsDnDItem
          key={currentField.id}
          id={currentField.id}
          field={currentField}
          onUpdateHandler={onUpdateHandler}
          selectFieldId={selectFieldId}
          title={currentField.dashboard.title}
          cssColumnWidth={currentField.cssColumnWidth}
          index={index - countFixFields}
          moveField={moveField}
          countFixFields={countFixFields}
          onShift={onShift}
          onSelect={onSelect}
          onUpdate={onUpdate}
        />
      );
    }, []);

    return (
      <div>
        <Scrollbars style={{ minHeight: "150px", maxHeight: "300px" }} autoHide={false}>
          <div className={styles.fieldsConstructorContainer}>{fields.map((field, i) => renderField(field, i))}</div>
        </Scrollbars>
      </div>
    );
  }
};
